module.exports = __webpack_public_path__ + "img/ring_r_l_0_null@3x.b03c19a2.png";